<template>
  <div>
    <!-- For Free Text -->
    <div v-html="data.questionFreeText"></div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      default: () => {}
    }
  }
};
</script>
